import React, { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png'; // 로고 이미지 import
import logoBlack from '../assets/images/logo_black.png';
import DropdownNav from "component/DropdownNav";

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // 페이지 이동 시 스크롤 최상단으로 이동
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);


    return (
        <div className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="logo">
                    <Link to="/main">
                        <img src={isScrolled ? logoBlack : logo}  alt="INISSOFT" className="logo-img" />
                    </Link>
                </div>

                <DropdownNav />               
            </div>  
        </div>
    )
}
export default Header